import Router from '../Router';
import { PasswordController } from '../../controllers';

export default class PasswordRouter extends Router {

	/**
	 * Describe which routes only for guests
	 * and auth user don't have access to them
	 * @return {{home: boolean, registration: boolean}}
	 */
	guestOnly(){
		return {
			passwordChange: false,
			passwordChangeConfirmation: false,
		}
	}

	authOnly() {
		return {
			passwordChange: false,
			passwordChangeConfirmation: false,
		}
	}

	initialize(options) {
		this.typeMenu = 'change_password';
		this.controller = new PasswordController(options);
	}

	get appRoutes() {
		return {
			'change-password': 'passwordChange',
			'change-password-confirmation': 'passwordChangeConfirmation'
		};
	}
}